const getFacilityPhone = ({ facility, value }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  if (facility && facility['Company Contact'] && facility['Company Contact'].ID) {
    return facility['Company Contact']['Phone Number'];
  }
  return null;
};

export default getFacilityPhone;



// WEBPACK FOOTER //
// ./src/utils/print/getFacilityPhone.js